module.exports = __webpack_public_path__ + "media/images/google_ad_manager/300x250-f0a36d6bc2c3fa35f0c3c29cd9ba7107.png";